import styled from 'styled-components'

import { colors } from 'themes'
import token from 'images/token.svg'

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: white;
	border-radius: 14px;
	margin: 10px 0;
	
	:hover {
		opacity: 0.89;
	}
	transition: 200ms ease;
`

export const TokenIcon = styled.img.attrs({
	src: token,
})`
	width: 42.17px;
	align-self: stretch;
	object-fit: contain;
	margin: 20px;
	
	@media (max-width: 400px) {
		margin: 20px 8px;
	}
`

export const Text = styled.div`
	margin-left: 10px;
	text-align: left;
	line-height: 1.5em;
	
	color: ${colors.tokens.text};
	
	p {
		margin: 1.5px;
		display: inline;
	}
	
	.top {
		font-weight: bold;
		font-size: 1.28em;
	}
	
	.bottom { 
		font-size: 1em;
	}
	
	.discount {
		white-space: nowrap;
		margin-left: 7px;
		padding: 3px 6px;
		
		border-radius: 3px;
		font-weight: bold;
		font-size: 0.78em;
		background: ${colors.tokens.discountBackground};
		color: white;
		text-align: center;
	}
`
